import React from 'react'
import StackedBarchart from '../stacked-bar-chart';

export default function COQPlot(props) {
    return (
        <div className=''>
            <span className='small'>Root Cause</span>
            <StackedBarchart data={ props.data} stackedBarChartFIlterCallback={props.filterOnCall} dataType="quality" type={'COQquality'} parentCallback={props.parentCallback}/>
        </div>
    );
}
